const JpTableActionsCol = ({ children, className = '' }) => {

    return (
        <div className={`d-flex text-primary align-items-center ${className}`}>
            {children}
        </div>
    )
}

export default JpTableActionsCol